export enum AppointmentAction {
  CANCEL = "cancel_appointment",
  EDIT = "edit_appointment",
  CONNECT = "connect_to_appointment"
}